module.exports = __webpack_public_path__ + "media/wave_solder_pallets/through-hole-components-cda7d794.png";